import { z } from 'zod'

import type { Actor } from './actor-names'

const actorType = z.enum(['user', 'apiClient', 'system'])

/**
 * When a record was created and last changed, and by whom, as every record the API sends
 * carries it (`IAuditable`). Spread into a record's own schema with `.extend(auditShape)`.
 */
export const auditShape = {
  createdOn: z.string(),
  createdByType: actorType,
  createdById: z.string(),
  modifiedOn: z.string(),
  modifiedByType: actorType,
  modifiedById: z.string(),
}

export const auditSchema = z.object(auditShape)

export type Audit = z.infer<typeof auditSchema>

/** The actor who created the record. */
export function createdBy(audit: Audit): Actor {
  return { type: audit.createdByType, id: audit.createdById }
}

/** The actor who last changed the record. */
export function modifiedBy(audit: Audit): Actor {
  return { type: audit.modifiedByType, id: audit.modifiedById }
}
